import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useClientUserQuery, useUpdateProfileMutation } from "../../hooks";
import AccountForm from "../forms/AccountForm";

const noop = () => undefined;

export type AccountUpdateDrawerProps = {
  /* TODO: [sc-41928] remove 'updatePhoneNumber' as this is temporary fix */
  updatePhoneNumber?: boolean;
  onSuccess?: () => void;
};

const AccountUpdateDrawer = ({
  updatePhoneNumber = false,
  onSuccess = noop,
}: AccountUpdateDrawerProps) => {
  const { data: clientUser, isLoading, error } = useClientUserQuery();
  const { close } = useCurrentDrawer();
  const handleOnSuccess = () => {
    close();
    onSuccess();
  };

  const {
    mutate: updateProfile,
    isPending: isUpdating,
    isSuccess: isUpdateSuccess,
    error: updateError,
  } = useUpdateProfileMutation({
    onSuccess: handleOnSuccess,
  });

  if (isLoading) {
    return <DrawerLayout.Loading />;
  }

  if (!clientUser || error) {
    return <DrawerLayout.FetchError error={error} entityName="account" />;
  }
  /* TODO: [sc-41928] fix title to remove 'phone number' */
  const title = updatePhoneNumber ? "Update name, email & phone number" : "Update name & email";

  return (
    <DrawerLayout>
      <DrawerLayout.Header title={title} onClose={close} />
      <AccountForm
        submitText="Update Account"
        isLoading={isUpdating || isUpdateSuccess}
        /* TODO: [sc-41928] remove 'updatePhoneNumber' as this is temporary fix */
        updatePhoneNumber={updatePhoneNumber}
        initialValues={{
          email: clientUser.primary_contact_email?.email ?? "",
          first_name: clientUser.first_name ?? "",
          last_name: clientUser.last_name ?? "",
          phone_number: clientUser.primary_contact_number?.number
            ? `${clientUser.primary_contact_number?.number}`
            : "",
        }}
        error={updateError}
        fieldErrors={{
          email: updateError?.errors.email,
          first_name: updateError?.errors.first_name,
          last_name: updateError?.errors.last_name,
          /* TODO: [sc-41928] remove 'phone_number' as this is temporary fix */
          phone_number: updateError?.errors.phone_number,
        }}
        onSubmit={(values) => updateProfile({ ...values })}
      />
    </DrawerLayout>
  );
};

export default AccountUpdateDrawer;
